import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SearchBar from './SearchBar';
import LegacySearchBar from './LegacySearchBar';
import UserActions from './UserActions';
import Bookmarks from './Bookmarks';
import logo from '../../../../icons/logo_release.svg';

import './Header.scss';

class Header extends Component {
  render() {
    const FEATURE_QUICK_FIND_ENABLED = JSON.parse(process.env.FEATURE_QUICK_FIND_ENABLED || false);

    return (
      <header className="main-header">
        <div className="main-header-logo">
          <Link className="logo" to="/">
            <img src={logo} alt="Bloomberg Media Distribution"/>
          </Link>
        </div>
        <div className="main-header-searchbar">{ FEATURE_QUICK_FIND_ENABLED ? <SearchBar /> : <LegacySearchBar /> }</div>
        <div className="main-header-bookmarks"><Bookmarks /></div>
        <div className="main-header-user-actions"><UserActions /></div>
      </header>
    );
  }
}

export default Header;
